import { ButtonHTMLAttributes, forwardRef } from 'react';
import {
  TResource,
  TResourceGroupType,
  TResourceType,
} from '@fe-learner-common';
import { Detail } from './Detail';
import { Link } from './Link';
import { QuizSurvey } from './QuizSurvey';

export type ResourceTexts = {
  new: string;
  groupTypes: Record<TResourceGroupType | 'quiz' | 'survey', string>;
};

export type ListItemProps = {
  resource: TResource;
  participationId: string;
  onResourceClick: (resourceId: string) => void;
  texts: ResourceTexts;
  container: HTMLElement;
};

export type ResourceListItemProps = Omit<
  ButtonHTMLAttributes<HTMLButtonElement>,
  'resource'
> &
  ListItemProps;

export const ResourceListItem = forwardRef<
  HTMLButtonElement,
  ResourceListItemProps
>(
  (
    { resource, participationId, onResourceClick, texts, container, ...rest },
    ref,
  ) => {
    switch (resource.componentType as TResourceType) {
      case 'material-oembedvideo':
      case 'material-poembedvideo':
      case 'material-wevideo':
      case 'material-vimeo2video':
      case 'material-youtubevideo':
      case 'material-diplomavideo':
      case 'material-vimeovideo':
      case 'material-brightcovevideo':
      case 'material-image':
      case 'material-unsplashimage':
      case 'material-audioplayer':
      case 'material-htmlsnippet':
        return (
          <Detail
            resource={resource}
            participationId={participationId}
            onResourceClick={onResourceClick}
            texts={texts}
            ref={ref}
            {...rest}
          />
        );

      case 'material-crisp':
      case 'material-external':
      case 'material-linkedsubproject':
      case 'material-genericfile':
      case 'material-website':
      case 'material-scorm':
        return (
          <Link
            resource={resource}
            participationId={participationId}
            texts={texts}
          />
        );

      case 'material-scorequiz':
      case 'material-quiz':
        return (
          <QuizSurvey
            container={container}
            resource={resource}
            participationId={participationId}
            texts={texts}
          />
        );

      default:
        console.error('ResourceListItem: unknown resource type', resource);
        return null;
    }
  },
);
ResourceListItem.displayName = 'ResourceRow';
